<div class="flex justify-between mb-6">
  <button mat-icon-button aria-label="Back" pdNavigateBack>
    <mat-icon>arrow_back</mat-icon>
  </button>

  <pd-app-title sizeClass="text-5xl"></pd-app-title>

  <span class="spacer"></span>
</div>

<h1>Child Safety Standards</h1>

<ol>
  <li>
    <h3>Strict 18+ Requirement</h3>

    <p>
      PersonaliDate is strictly for users aged 18 and older. We do not knowingly
      allow minors to use the platform. Any accounts found to belong to
      individuals under the age of 18 will be immediately and permanently
      terminated.
    </p>
  </li>

  <li>
    <h3>Zero Tolerance for CSAE and CSAM</h3>

    <p>
      We have a zero-tolerance policy regarding Child Sexual Abuse and
      Exploitation (CSAE) and Child Sexual Abuse Material (CSAM). This includes,
      but is not limited to:
    </p>

    <ul>
      <li>
        Sharing, uploading, or soliciting sexually explicit content involving
        minors.
      </li>
      <li>Grooming behavior or any attempts to exploit children.</li>
    </ul>
  </li>

  <li>
    <h3>Enforcement and Reporting to Authorities</h3>

    <p>
      Upon gaining actual knowledge of CSAM or child exploitation on our
      platform, PersonaliDate will:
    </p>

    <ul>
      <li>Immediately remove the offending content.</li>
      <li>Permanently ban the responsible user account.</li>
      <li>
        Report all confirmed instances of CSAM to the National Center for
        Missing & Exploited Children (NCMEC) and other relevant law enforcement
        agencies as required by law.
      </li>
    </ul>
  </li>

  <li>
    <h3>In-App Reporting Mechanism</h3>

    <p>
      Users can report child safety concerns or suspected underage users
      directly within the PersonaliDate app using our built-in reporting tools.
      All reports are reviewed promptly by our moderation team.
    </p>
  </li>

  <li>
    <h3>Contact Information</h3>

    <p>
      For questions regarding these standards, please

      <a href="mailto:support@PersonaliDate.com">
        contact our Child Safety Point of Contact
      </a>
      .
    </p>
  </li>
</ol>
